export const formatDate = (date: Date): string => {
    const options: Intl.DateTimeFormatOptions = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        weekday: 'long',
        hour: 'numeric',
        minute: 'numeric',
        hour12: false,
    };

    const formatter = new Intl.DateTimeFormat('ru-RU', options);
    const formattedDate = formatter.format(date);

    // Mapping full weekday names to abbreviated forms
    const weekdaysAbbreviated: Record<string, string> = {
        'понедельник': 'ПН',
        'вторник': 'ВТ',
        'среда': 'СР',
        'четверг': 'ЧТ',
        'пятница': 'ПТ',
        'суббота': 'СБ',
        'воскресенье': 'ВС',
    };

    // Extracting parts and using the abbreviated form
    const parts = formattedDate.split(', ');
    const dayMonthYear = parts[1].split(' ');
    const weekday = weekdaysAbbreviated[parts[0].toLowerCase()];

    return `${dayMonthYear[0]} ${dayMonthYear[1]} ${dayMonthYear[2]} ${weekday}`;
};


